import { EditDomesForm, AddDomesForm } from '../../forms';
import React, { useState } from 'react';
import { DomesManagementService } from '../../services';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

interface AddDomesInterface {
  id: string;
}

const ManageDomesComponent: React.FC = () => {
  const { id } = useParams();
  const [loader, setLoader] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const editDome: boolean = location.pathname.includes('edit');
  const [error, setError] = useState('');
  const handleSubmitForm = async (data: any) => {
    setLoader(true);
    const form = new FormData();
    form.append('file', data.selectedIcon[0]);
    const selectedImageS3Url = await DomesManagementService.uploadpicture(form);

    DomesManagementService.addDomes({
      name: data.domeName,
      description: data.description,
      selectedImage: selectedImageS3Url.data.data.url,
      nonSelectedImage: selectedImageS3Url.data.data.url,
    }).then(() => {
      setLoader(false);
      navigate('/domesmanagement');
    }).catch((err: any) => {
      setLoader(false);
      setError(err.response.data.message);
    });
  };
  const handleSaveAsDraftAddomes = async (e: any, data: any) => {
    e.preventDefault();
    setLoader(true);
    let selectedImageS3Url: any = '';
    if (data.domeName.length > 0) {
      if (typeof (data.selectedIcon) !== 'string' && data.selectedIcon !== null && data.selectedIcon !== undefined) {
        const form = new FormData();
        form.append('file', data.selectedIcon[0]);
        selectedImageS3Url = await DomesManagementService.uploadpicture(form);
      }
      const iconImages = selectedImageS3Url === '' ? {} : {
        selectedImage: selectedImageS3Url.data.data.url,
        nonSelectedImage: selectedImageS3Url.data.data.url,
      };

      DomesManagementService.saveDomesToDraft({
        name: data.domeName,
        description: data.description,
        ...iconImages,
      }).then(() => {
        setLoader(false);
        navigate('/domesmanagement');
      }).catch((err: any) => {
        setLoader(false);
        setError(err.response.data.message);
      });
    } else {
      setLoader(false);
      setError(() => 'Domes Name cannot be empty for draft');
    }
  };

  const handleSaveAsDraft = async (e: any, data: any) => {
    e.preventDefault();
    setLoader(true);
    let selectedImageS3Url: any = '';

    if (data.domeName.length > 0) {
      if (typeof (data.selectedIcon) !== 'string' && data.selectedIcon !== null && data.selectedIcon !== undefined) {
        const form = new FormData();
        form.append('file', data.selectedIcon[0]);
        selectedImageS3Url = await DomesManagementService.uploadpicture(form);
      }
      const iconImages = selectedImageS3Url === '' ? {} : {
        selectedImage: selectedImageS3Url.data.data.url,
        nonSelectedImage: selectedImageS3Url.data.data.url,
      };

      DomesManagementService.savePutDomesToDraft({
        name: data.domeName,
        description: data.description,
        ...iconImages,
        categoryId: id,
      }).then(() => {
        setLoader(false);
        navigate('/domesmanagement');
      }).catch((err: any) => {
        setLoader(false);
        setError(err.response.data.message);
      });
    } else {
      setLoader(false);
      setError(() => 'Domes Name cannot be empty for draft');
    }
  };

  const handleSubmitFormEdit = async (data: any) => {
    setError('');
    let flag = true;
    const FILE_SIZE = 50 * 1024 * 1024;
    const SUPPORTED_FORMATS = [
      'image/jpg',
      'image/jpeg',
      'image/png',
    ];
    let selectedImageS3Url: any = '';
    setLoader(true);

    if (data.selectedIcon === null || data.selectedIcon === undefined) {
      flag = false;
      setLoader(false);
      setError(() => 'Please fill all required fields');
    }
    if (typeof (data.selectedIcon) !== 'string' && flag) {
      if (data.selectedIcon[0].size >= FILE_SIZE) {
        flag = false;
        setLoader(false);
        setError(() => 'Selected Icon size must be less than 50 Mb');
      } else if (!SUPPORTED_FORMATS.includes(data.selectedIcon[0].type)) {
        flag = false;
        setLoader(false);
        setError(() => 'Selected Icon must be of type png/jpg');
      }
    }

    if (flag) {
      if (typeof (data.selectedIcon) !== 'string' && data.selectedIcon !== null) {
        const form = new FormData();
        form.append('file', data.selectedIcon[0]);
        selectedImageS3Url = await DomesManagementService.uploadpicture(form);
      }
      const iconUrl = selectedImageS3Url === '' ? data.selectedIcon : selectedImageS3Url.data.data.url;
      DomesManagementService.editDetails({
        categoryId: id,
        name: data.domeName,
        description: data.description,
        selectedImage: iconUrl,
        nonSelectedImage: iconUrl,
        status: 'unblocked',
      }).then(() => {
        setLoader(false);
        navigate('/domesmanagement');
      }).catch((err) => {
        setLoader(false);
        setError(err.response.data.message);
      });
    }
  };

  return (
    <>
      {!editDome ? (
        <AddDomesForm
          handleSubmit={handleSubmitForm}
          handleSaveAsDraft={handleSaveAsDraftAddomes}
          loader={loader}
          error={error}
        />
      ) : (
        <>
          <EditDomesForm
            handleSubmit={handleSubmitFormEdit}
            handleSaveAsDraft={handleSaveAsDraft}
            loader={loader}
            id={id as string}
            error={error}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  routing: state.routing,
});
const mapDispatchToProps = () => ({});

const ManageDomes = compose<React.ElementType>(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ManageDomesComponent);

export default ManageDomes;
